// `react-markdown` `components` map for the agentic/new-backend final-answer pipeline — same MUI
// element styling every markdown surface in this feature shares (`buildStyledMarkdownComponents`,
// `../../../components/messageRows/markdown/sharedMarkdownElements.js`), with this pipeline's own
// `[[type:len:payload]]`/`[[cite:id,...]]` marker substitution (`agenticMarkdownMarkers.js`)
// injected as the `wrapChildren` callback instead of the legacy `[[citations:JSON]]` grammar.
import React from 'react';
import {buildStyledMarkdownComponents} from '../../../components/messageRows/markdown/sharedMarkdownElements';
import {replaceAgenticMarkersInNode} from './agenticMarkdownMarkers';

/**
 * @param {{
 *   citations?: Array,
 *   onSelectComponent?: Function,
 *   onOpenCitations?: Function,
 *   sourceText?: string,
 * }} context
 * @returns {Record<string, Function>} a `react-markdown` `components` map.
 */
export function buildAgenticMarkdownComponents(context) {
    const wrapChildren = (children, keyPrefix) =>
        replaceAgenticMarkersInNode(React.Children.toArray(children), context, keyPrefix);
    const styled = buildStyledMarkdownComponents(wrapChildren);

    return styled;
}

export default buildAgenticMarkdownComponents;
